module.exports = __webpack_public_path__ + "img/START-alt.8de86633.svg";